import { getToday, isSameDay } from '../date'
import { isAnyBlank, isBlank } from '../string'
import { hasValidPhone } from '../phone'
import { hasValidEmail, isValidEmail } from '../email'

export const getEstado = _class => {
  if (_class === 'LEAD') return 'Lead'
  if (_class === 'LEAD_NO_VALIDO') return 'Lead no valido'
  if (_class === 'PRUEBA') return 'Prueba'
  if (_class === 'LEAD_CUALIFICADO') return 'Lead cualificado'
  if (_class === 'CLIENTE_CAPTADO') return 'Cliente Captado'
  if (_class === 'CLIENTE_PERDIDO') return 'Cliente Perdido'
  if (_class === 'LEAD_DERIVADO') return 'Lead Derivado'
}

export const getSituacion = _class => {
  if (['LEAD', 'PRUEBA', 'LEAD_CUALIFICADO'].includes(_class)) return 'Abierto'
  if (['LEAD_NO_VALIDO', 'CLIENTE_PERDIDO', 'LEAD_DERIVADO'].includes(_class))
    return 'Perdido'
  if (_class === 'CLIENTE_CAPTADO') return 'Captado'
}

export const getEstadoContacto = fechaContacto => {
  const hoy = getToday()
  if (isSameDay(fechaContacto, hoy)) return 'normal'
  if (fechaContacto < hoy) return 'late'
  if (fechaContacto > hoy) return 'early'
}

export const validarLead = nuevoLead => {
  const {
    personaContacto,
    nombreContacto,
    emails,
    telefonos,
    academia,
    formaContacto,
    comoConoce,
    estadoLead,
    fechaPrueba,
    horaPrueba,
    asignaturaPrueba,
    academiaPrueba
  } = nuevoLead

  const result = {
    isValid: true,
    errors: [],
    warnings: []
  }

  if (isBlank(personaContacto)) {
    result.isValid = false
    result.errors.push('Es necesario indicar la persona de contacto')
  }

  if (isBlank(nombreContacto)) {
    result.isValid = false
    result.errors.push('El nombre del contacto es obligatorio')
  }

  // Permitimos asignar un lead a central
  if (isBlank(academia) && academia !== ' ') {
    result.isValid = false
    result.errors.push(
      'Es necesario asignar el lead a una academia (o a central)'
    )
  }

  if (isBlank(estadoLead)) {
    result.isValid = false
    result.errors.push('Es necesario indicar el estado del lead')
  }

  if (isBlank(comoConoce)) {
    result.isValid = false
    result.errors.push('Es necesario indicar cómo ha conocido mundoestudiante')
  }

  if (isBlank(formaContacto)) {
    result.isValid = false
    result.errors.push('Es necesario indicar la forma de contacto')
  }

  if (
    estadoLead === 'PRUEBA' &&
    isAnyBlank(fechaPrueba, horaPrueba, asignaturaPrueba, academiaPrueba)
  ) {
    result.isValid = false
    result.errors.push('Es necesario indicar todos los datos de la prueba')
  }

  if (!hasValidPhone(telefonos)) {
    result.isValid = false
    result.errors.push(
      'No se ha proporcionado ningún teléfono válido para este lead'
    )
  }

  if (!hasValidEmail(emails)) {
    result.warnings.push(
      'No se ha proporcionado ningún email válido para este lead'
    )
  }

  const emailInvalido = (emails || []).some(
    e => !isBlank(e.email) && !isValidEmail(e.email)
  )
  if (emailInvalido) {
    result.warnings.push('Alguno de los emails no tiene un formato válido')
  }

  return result
}
